module.exports = __webpack_public_path__ + "static/media/YM36_0.5365d812.jpg";